import { motion } from "framer-motion";
import { UserPlus, Users, FileCheck, Moon } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    title: "Regístrate en 2 minutos",
    description: "Solo RFC y contraseña SAT. Sin papeleo ni filas.",
  },
  {
    icon: Users,
    title: "Te asignamos un contador",
    description: "Él revisa tu situación fiscal y te conoce.",
  },
  {
    icon: FileCheck,
    title: "Nosotros declaramos por ti",
    description: "Tú solo apruebas desde tu celular. Así de fácil.",
  },
  {
    icon: Moon,
    title: "Duerme tranquilo",
    description: "Alertas inteligentes. Nunca más multas ni recargos.",
  },
];

export function HowItWorksSection() {
  return (
    <section className="section-padding bg-muted/30">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
            Cómo funciona
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            En 4 simples pasos, olvídate para siempre del estrés fiscal
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          {/* Connection Line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-secondary via-secondary/50 to-transparent hidden md:block -translate-x-1/2" />

          <div className="space-y-12 md:space-y-0">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className={`relative flex flex-col md:flex-row items-center gap-6 md:gap-12 ${
                  i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
              >
                {/* Content */}
                <div className={`flex-1 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                  <div className="glass-card p-6 inline-block">
                    <h3 className="text-xl font-heading font-bold mb-2">{step.title}</h3>
                    <p className="text-muted-foreground">{step.description}</p>
                  </div>
                </div>

                {/* Icon */}
                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center shadow-lg">
                    <step.icon className="w-7 h-7 text-secondary-foreground" />
                  </div>
                  <div className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-accent flex items-center justify-center text-accent-foreground text-xs font-bold">
                    {i + 1}
                  </div>
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden md:block" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
